var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Component } from "@theme/component";
class VideoBackgroundComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["videoSources", "videoElement"]);
  }
  connectedCallback() {
    super.connectedCallback();
    const { videoSources, videoElement } = this.refs;
    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute("src", videoSource);
    }
    videoElement.load();
  }
}
if (!customElements.get("video-background-component")) {
  customElements.define("video-background-component", VideoBackgroundComponent);
}
export {
  VideoBackgroundComponent
};
